<template>
  <a-card :bordered="false">
    <Breadcrumb routeName="UserList" toName="用户详情" goPathName="用户列表"></Breadcrumb>
    <div>
      <div class="tr">
        <div class="left-style">ID:</div>
        {{ detailList.memberId }}
      </div>
      <div class="tr">
        <div class="left-style">昵称:</div>
        {{ detailList.nickName }}
      </div>
      <div class="tr">
        <div class="left-style">头像:</div>
        <img v-if="detailList.avatarUrl" class="picture" :src="detailList.avatarUrl">
        <img v-else class="picture" src="../../assets/personla.png">
      </div>
      <div class="tr">
        <div class="left-style">性别:</div>
        {{ detailList.sex|sexTypeName }}
      </div>
      <div class="tr">
        <div class="left-style">国家:</div>
        {{ detailList.nation }}
      </div>
      <div class="tr">
        <div class="left-style">省份:</div>
        {{ detailList.province }}
      </div>
      <div class="tr">
        <div class="left-style">城市:</div>
        {{ detailList.city }}
      </div>
      <div class="tr">
        <div class="left-style">手机号:</div>
        {{ detailList.mobileNo }}
      </div>
      <div class="tr">
        <div class="left-style">累计订单数:</div>
        {{ detailList.totalOrderNum }}
      </div>
      <div class="tr">
        <div class="left-style">累计消费金额:</div>
        {{ detailList.totalAmount }}
      </div>
      <div class="tr">
        <div class="left-style">最近访问时间:</div>
        {{ detailList.lastLoginTimeStr }}
      </div>
      <div class="tr">
        <div class="left-style">状态:</div>
        {{ detailList.status|userDetailTypeName }}
      </div>
      <div class="tr">
        <div class="left-style">用户标签:</div>
        <span class="users-tag" v-for="item in tagData" :key="item">{{ item }}</span>
      </div>
      <div class="tr">
        <div class="left-style">
        </div>
        <a-button type="primary" @click="showModal">管理标签</a-button>
        <a-button style="margin-left:20px;" @click="back">返回</a-button>
      </div>
    </div>
    <div>
      <a-modal
        title="用户标签"
        :visible="visible"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <search-page-view
          :col="3"
          ref="pageList"
          :columns="columns"
          row-key="tagId"
          requestType="get"
          :enableSearch="false"
          :requestPromise="loadPromise"
        >
          <span slot="action" slot-scope="rowItem">
            <a v-if="rowItem.record.type == 1">
              <a v-if="rowItem.record.status==0" @click="signTag(rowItem.record)">标记</a>
              <a v-else @click="removeTag(rowItem.record)">移除</a>
            </a>
          </span>
          <span slot="type" slot-scope="rowItem">{{ rowItem.text|userTagTypeName }}</span>
          <span slot="status" slot-scope="rowItem">{{ rowItem.text|tagStatusName }}</span>
        </search-page-view>
      </a-modal>
    </div>
  </a-card>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'

export default {
  name: 'UserDetail',
  components: {
    Breadcrumb
  },
  data() {
    return {
      visible: false,
      detailList: [],
      memberId: '',
      loadPromise: params => this.getLabelManage(this.memberId),
      columns: [
        {
          title: 'ID',
          dataIndex: 'tagId'
        },
        {
          title: '标签名称',
          dataIndex: 'name'
        },
        {
          title: '标签类型',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' }
        },
        {
          title: '标签状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      tagData: []
    }
  },
  mounted() {
    this.memberId = this.$route.query.memberId
    this.getDetailsList(this.memberId)
  },
  methods: {
    //获取用户详情信息
    getDetailsList(memberId) {
      const id = { id: memberId }
      this.getHttpServices().getUserService().get('api/v2/member/detail', id)
        .then(detail => {
          this.detailList = detail
          this.tagData = detail.tagResponseList
          this.getLogUtils().logWithTag('用户标签列表', this.tagData)
          this.getLogUtils().logWithTag('用户详情', detail)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getLabelManage(memberId) {
      const mid = { memberId: memberId }
      return this.getHttpServices().getUserService().get('api/v2/member/tag/listAll', mid)
    },
    back() {
      this.$router.go(-1)
    },
    showModal() {
      this.visible = true
      this.getLabelManage(this.memberId)
    },
    handleOk(e) {
      this.visible = false
    },
    handleCancel(e) {
      this.visible = false
    },
    //标签管理 标记
    signTag(record) {
      this.getHttpServices().getUserService().post('api/v2/member/tag/mark', {
        memberId: this.memberId,
        tagId: record.tagId
      })
        .then(res => {
          this.$message.success('成功标记')
          this.$refs.pageList.refresh()
          this.getDetailsList(this.memberId)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    //标签管理 移除
    removeTag(record) {
      this.getHttpServices().getUserService().post('api/v2/member/tag/remove', {
        memberId: this.memberId,
        tagId: record.tagId
      })
        .then(res => {
          this.$message.success('成功移除')
          this.$refs.pageList.refresh()
          this.getDetailsList(this.memberId)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    }
  }
}
</script>
<style scoped>
.picture {
  width: 100px;
  height: 100px;
  border: none;
}

.users-tag {
  margin-right: 20px;
}

.tr {
  font-size: 14px;
  display: flex;
  margin: 20px 0;
}

.left-style {
  width: 110px;
  margin-right: 20px;
  text-align: right;
}

.right-style {
  text-align: left;
  width: 30%;
}

</style>